import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';

const clearVolumesCacheForRequest = (request: Promise<any>) => {
  cacheService.removeAllInPath(`/author/curriculum/volumes`);
  return request;
};

export const removeVolume = (volumeId: string, initiatingUserId: string) =>
  clearVolumesCacheForRequest(
    submitCommand(volumeId, { id: volumeId, initiatingUserId }, 'CvDeleteVolume', 'CvVolumeDeleted', 'CvCommandFailed')
  );
